import React, { memo } from 'react';
import { string, func, bool } from 'prop-types';

const FundraiserSwitch = ({ label, onChange, value, className, ...rest }) => {
  const onClick = () => {
    if (onChange) {
      onChange();
    }
  };

  return (
    <div className={`flex justify-start items-center ${className}`}>
      <input
        type="checkbox"
        className="opacity-0 w-0 h-0"
        checked={value}
        readOnly
        {...rest}
      />
      <div
        className={`btn w-9 h-2 flex items-center border rounded-full py-1 px-0 duration-500 ease-in-out cursor-pointer ${
          value
            ? 'bg-brand-primary border-brand-primary'
            : 'bg-white border-gray-200'
        }`}
        onClick={onClick}
        data-testid="toggle-switch"
      >
        <div
          className={`bg-white w-4 h-4 rounded-full shadow transform duration-500 ease-in-out ${
            value ? 'translate-x-5' : 'translate-x-0'
          }`}
        ></div>
      </div>
      <p className="text-gray-400 text-xs ml-2 text-right tracking-widest">
        {label}
      </p>
    </div>
  );
};

FundraiserSwitch.propTypes = {
  label: string,
  onChange: func,
  value: bool.isRequired,
  className: string,
};
FundraiserSwitch.defaultProps = {
  label: 'LIVE',
  className: '',
};

export default memo(FundraiserSwitch);
